var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoriana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 444 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.717,59.493C39.374,59.493 37.512,60.059 36.16,61.899C35.912,62.235 35.709,62.662 35.589,63.081C35.176,64.515 35.466,66.094 36.371,67.303C37.068,68.232 37.955,68.929 38.739,69.542C39.123,69.844 39.933,70.603 40.195,70.925C40.587,71.408 40.883,71.695 41.236,72.759C41.451,73.406 41.484,74.257 41.377,74.737C43.829,72.281 46.507,69.092 46.507,65.625C46.507,61.639 43.622,59.493 40.717,59.493Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.882,73.11C34.863,71.712 33.688,70.864 32.715,69.97C32.294,69.583 31.831,69.294 31.485,68.947C29.841,67.299 29.071,65.263 29.46,62.76C29.767,60.796 30.733,59.506 31.901,58.558C30.508,57.527 28.853,56.969 26.985,56.969C22.349,56.969 18.475,60.729 18.591,65.367C18.802,73.736 29.189,80.865 33.467,82.326C35.759,81.139 36.972,78.932 36.972,76.663C36.972,75.008 36.27,73.644 35.882,73.11Z",
    style: {
      fill: "rgb(174,191,54)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.007,75.382L122.007,73.88L122.45,73.88L122.715,74.904L122.977,73.88L123.423,73.88L123.423,75.382L123.148,75.382L123.148,74.2L122.858,75.382L122.57,75.382L122.281,74.2L122.281,75.382L122.007,75.382Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.051,65.622L63.193,63.402C61.953,62.133 60.223,61.226 58.091,61.226C54.097,61.226 52.659,63.636 52.659,65.754C52.659,68.181 54.044,68.902 55.767,69.566C57.35,70.17 57.96,70.551 57.96,71.265C57.96,73.182 54.919,72.786 52.616,71.216L50.929,74.059C52.777,75.256 54.476,75.662 56.176,75.662C59.561,75.662 61.932,73.748 61.932,70.907C61.932,68.996 60.943,68.01 58.679,67.111C57.115,66.489 56.505,66.139 56.505,65.312C56.505,64.199 58.367,63.367 61.051,65.622Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.587,73.143C67.016,73.143 66.51,72.885 66.51,71.329C66.51,70.362 66.839,66.85 68.653,66.85C69.355,66.85 69.789,67.478 69.732,68.565C69.639,70.195 69.259,73.143 67.587,73.143ZM69.175,64.333C67.695,64.333 64.498,64.854 63.355,68.728C62.637,71.164 62.376,75.71 67.067,75.71C68.545,75.71 71.8,75.187 72.939,71.315C74.15,67.217 72.907,64.333 69.175,64.333Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.54,64.626L84.059,64.626L82.172,75.382L85.652,75.382L87.54,64.626Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.231,71.721C93.998,72.89 93.4,73.203 92.762,73.203C91.915,73.203 91.524,72.759 91.524,71.228C91.524,69.801 92.19,66.763 94.209,66.763C94.518,66.763 94.956,66.862 95.073,66.944L94.231,71.721ZM94.773,64.337C90.544,64.337 88.029,67.336 88.029,71.756C88.029,73.961 88.963,75.689 91.304,75.689C92.367,75.689 93.501,75.3 94.175,74.404C94.264,74.286 94.317,74.338 94.317,74.451L94.292,75.382L97.273,75.382L97.397,73.209L98.802,65.197C97.973,64.78 96.073,64.337 94.773,64.337Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.038,71.721C116.806,72.89 116.208,73.203 115.568,73.203C114.721,73.203 114.33,72.759 114.33,71.228C114.33,69.801 114.995,66.763 117.011,66.763C117.32,66.763 117.762,66.862 117.878,66.944L117.038,71.721ZM117.577,64.337C113.353,64.337 110.833,67.336 110.833,71.756C110.833,73.961 111.77,75.689 114.109,75.689C115.173,75.689 116.309,75.3 116.983,74.404C117.068,74.286 117.123,74.338 117.123,74.451L117.098,75.382L120.078,75.382L120.202,73.209L121.609,65.197C120.779,64.78 118.882,64.337 117.577,64.337Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.728,65.673L103.726,64.625L100.839,64.625L100.773,66.629L99.233,75.382L102.716,75.382L103.934,68.481C104.089,67.563 104.721,67.008 105.429,67.008C106.052,67.008 106.396,67.351 106.238,68.393C106.165,68.884 105.014,75.372 105.014,75.372L108.506,75.372C108.506,75.372 109.622,69.167 109.831,67.929C110.276,65.268 108.912,64.35 107.145,64.35C105.698,64.35 104.622,64.92 103.908,65.713C103.822,65.81 103.728,65.804 103.728,65.673Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.494,66.08C78.465,66.124 78.44,66.108 78.433,66.044L78.415,64.626L75.579,64.626L75.512,66.629L73.979,75.382L77.461,75.382L78.581,69.017C78.902,67.135 80.598,66.934 81.845,67.683L82.874,64.757C81.511,64.017 79.726,64.116 78.494,66.08Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.205,61.305C88.205,62.285 87.488,63.132 86.326,63.311C85.288,63.47 84.441,62.91 84.441,61.884C84.441,60.815 85.235,60.044 86.326,59.88C87.362,59.718 88.205,60.36 88.205,61.305Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-77.4519,-237.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.237,74.516L124.017,74.516L124.017,74.135L124.248,74.135C124.363,74.135 124.44,74.137 124.461,74.139C124.512,74.148 124.55,74.167 124.574,74.199C124.601,74.23 124.614,74.271 124.614,74.322C124.614,74.365 124.606,74.404 124.584,74.434C124.565,74.463 124.535,74.487 124.504,74.498C124.464,74.51 124.376,74.516 124.237,74.516ZM124.859,75.091C124.788,74.974 124.734,74.893 124.69,74.846C124.65,74.798 124.596,74.759 124.531,74.721C124.661,74.701 124.758,74.655 124.822,74.582C124.887,74.509 124.919,74.415 124.919,74.302C124.919,74.214 124.899,74.135 124.854,74.064C124.814,73.997 124.755,73.947 124.682,73.922C124.614,73.893 124.499,73.88 124.344,73.88L123.719,73.88L123.719,75.382L124.017,75.382L124.017,74.756L124.078,74.756C124.143,74.756 124.194,74.762 124.227,74.772C124.255,74.784 124.287,74.806 124.315,74.836C124.344,74.867 124.394,74.939 124.469,75.056L124.682,75.382L125.04,75.382L124.859,75.091Z",
    style: {
      fill: "rgb(236,50,43)",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoriana);
export default __webpack_public_path__ + "static/media/Soriana.b593d74cd2fdbb38ed10359c6155987e.svg";
export { ForwardRef as ReactComponent };